// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var StrikesAggregationStyle;
(function (StrikesAggregationStyle) {
    StrikesAggregationStyle[StrikesAggregationStyle["FromATMStrike"] = 0] = "FromATMStrike";
    StrikesAggregationStyle[StrikesAggregationStyle["CustomUnderlierPrice"] = 1] = "CustomUnderlierPrice";
})(StrikesAggregationStyle || (StrikesAggregationStyle = {}));
export function getStrikesAggregationStyleKey(value) {
    switch (value) {
        case StrikesAggregationStyle.FromATMStrike:
            return 'property.StrikesAggregationStyle.FromATMStrike';
        case StrikesAggregationStyle.CustomUnderlierPrice:
            return 'property.StrikesAggregationStyle.CustomUnderlierPrice';
        default:
            return '';
    }
}
